import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styles/About.css"; // Ensure CSS file is linked
import Background from "../Images/background.png";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

export default function About() {
  return (
    <>
      <Header />
      <div className="container py-5" style={{ marginTop: "4.5rem" }}>
        <div className="row align-items-center">
          {/* Left Side - Image & Hover Text */}
          <div className="col-lg-6 col-md-12 text-center mb-4">
            <div className="image-container">
              <img
                src={Background}
                alt="Background"
                className="img-fluid rounded shadow"
                style={{
                  width: "100%",
                  maxHeight: "600px",
                  objectFit: "cover",
                }}
              />
              {/* <div className="hover-text">
                KaaS is your ultimate learning platform, designed to elevate your
                personal and professional growth. With expertly crafted courses
                tailored to your needs, KaaS provides access to over 200 diverse
                topics.
              </div> */}
            </div>
          </div>

          {/* Right Side - Text Content */}
          <div className="col-lg-6 col-md-12">
            <div className="text-center text-lg-start">
              <h4 className="fw-bold text-primary">LEARN ANYTHING</h4>
              <h1 className="fw-bold">
                Benefits About Online Learning Expertise
              </h1>
            </div>
            <div className="mt-4">
              <div className="mb-4 p-3 border rounded shadow-sm bg-light">
                <h3 className="fw-bold text-dark">Flexibility in Learning</h3>
                <p className="text-secondary">
                  Online courses allow learners to access lectures, quiz,
                  assignments, and materials anytime and from anywhere. Whether
                  you're a working professional, a student, or managing a
                  household, online learning fits around your schedule.
                </p>
              </div>
              <div className="mb-4 p-3 border rounded shadow-sm bg-light">
                <h3 className="fw-bold text-dark">
                  Self-Paced & Personalized Learning
                </h3>
                <p className="text-secondary">
                  Unlike classroom environments with fixed timetables, online
                  courses let you learn at your own speed. If a concept is
                  difficult, you can review it multiple times. If it’s easy, you
                  can move faster.
                </p>
              </div>
              <div className="p-3 border rounded shadow-sm bg-light">
                <h3 className="fw-bold text-dark">
                  Interactive & Engaging Tools
                </h3>
                <p className="text-secondary">
                  Online platforms use videos, animations, quizzes, case
                  studies, and real-world projects to make learning engaging and
                  practical. Many also include discussion forums, live Q&A
                  sessions, group discussion and mentorship support
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container py-5">
          <div className="p-4 bg-light border rounded shadow-sm">
            <p
              style={{
                fontSize: "16px",
                lineHeight: "1.8",
                textAlign: "justify",
              }}
            >
              <span style={{ fontWeight: "700", color: "#000" }}>VetLearn</span>{" "}
              is an initiative by{" "}
              <span style={{ fontWeight: "700", color: "#000" }}>
                Vetrina Healthcare Pvt. Ltd.
              </span>
              , designed to transform the way learning and development happens
              in the animal health industry. With a strong foundation in
              veterinary science, animal nutrition, and rural enterprise,
              Vetrina has been a pioneer in building sustainable solutions for
              livestock and companion animal healthcare in India.
              <br />
              <br />
              <span style={{ fontWeight: "700", color: "#000" }}>
                VetLearn
              </span>{" "}
              provides a comprehensive digital learning platform focused on the
              dairy, poultry, sheep & goat, swine, and companion animal sectors.
              Our purpose is to centralize knowledge, foster entrepreneurship,
              and enhance professional competencies by delivering{" "}
              <span style={{ fontWeight: "700", color: "#000" }}>
                practical, research-backed, and expert-led training programs
              </span>
              .
              <br />
              <br />
              <span style={{ fontWeight: "700", color: "#000" }}>
                VetLearn
              </span>{" "}
              is more than a learning platform — it’s a capability-building
              ecosystem that connects learners, trainers, farmers, and
              professionals. Every course is designed with real-world
              application in mind, helping individuals upskill, gain
              certifications, and make meaningful contributions to animal
              healthcare and agri-livestock businesses.
              <br />
              <br />
              At Vetrina, we believe empowering livestock and companion animal
              stakeholders through innovative, expert-led, and technology-driven
              learning “to make livestock farming simple and profitable” and “to
              enhance the health of pets and happiness of pet parents.”
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
